module.exports = __webpack_public_path__ + "img/IMG_8932.8f11e26b.jpg";